import FootballHomePage from './FootballHomePage'

export default FootballHomePage